import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { walletAPI } from '@/services/api';
import { Coins } from 'lucide-react';

/**
 * Floating Mu Points balance pill — fetches /wallet/me, refreshes when the
 * `mu-wallet-changed` window event is dispatched. Mount once in dashboard layouts.
 */
export default function PointsBalance({ to = '/recruiter/wallet' }) {
  const [bal, setBal] = useState(null);

  const load = useCallback(async () => {
    try {
      const d = await walletAPI.me();
      setBal(d.balance);
    } catch {
      setBal(null);
    }
  }, []);

  useEffect(() => {
    load();
    const handler = () => load();
    window.addEventListener('mu-wallet-changed', handler);
    const t = setInterval(load, 60_000);
    return () => { window.removeEventListener('mu-wallet-changed', handler); clearInterval(t); };
  }, [load]);

  if (bal === null) return null;
  const low = bal < 20;
  const negative = bal < 0;

  return (
    <Link
      to={to}
      data-testid="mp-balance-pill"
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium border transition ${
        negative
          ? 'bg-red-500/10 border-red-500/30 text-red-700 dark:text-red-300 hover:bg-red-500/15'
          : low
            ? 'bg-amber-500/10 border-amber-500/30 text-amber-700 dark:text-amber-300 hover:bg-amber-500/15'
            : 'bg-emerald-500/10 border-emerald-500/30 text-emerald-700 dark:text-emerald-300 hover:bg-emerald-500/15'
      }`}
    >
      <Coins className="w-3.5 h-3.5" />
      <span>{bal} MP</span>
    </Link>
  );
}
